import React, { useEffect, useState, useRef } from 'react';
import { motion, useInView } from 'framer-motion';
interface AnimatedSectionProps {
  children: React.ReactNode;
  className?: string;
  delay?: number;
  stagger?: boolean;
}
export function AnimatedSection({
  children,
  className = '',
  delay = 0,
  stagger = false
}: AnimatedSectionProps) {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <motion.div ref={ref} initial={{
    opacity: 0,
    y: 50
  }} animate={isInView ? {
    opacity: 1,
    y: 0
  } : {
    opacity: 0,
    y: 50
  }} transition={{
    duration: 0.8,
    delay,
    ease: 'easeOut'
  }} className={className} data-id="element-212">
      {children}
    </motion.div>;
}